<template>
  <div class="change-password-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>修改密码</span>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area" v-loading="loading">
      <el-card class="password-card">
        <el-form :model="passwordForm" :rules="rules" ref="passwordForm" label-width="120px">
          <div class="form-section">
            <div class="section-title">密码修改</div>
            
            <el-form-item label="原密码" prop="oldPassword">
              <el-input
                v-model="passwordForm.oldPassword"
                type="password"
                placeholder="请输入原密码"
                show-password
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="新密码" prop="newPassword">
              <el-input
                v-model="passwordForm.newPassword"
                type="password"
                placeholder="请输入新密码"
                show-password
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input
                v-model="passwordForm.confirmPassword"
                type="password"
                placeholder="请再次输入新密码"
                show-password
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </div>

          <div class="form-actions">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSubmit">保存</el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { change_user_password } from '@/api/modules/user'

export default {
  name: 'ChangePassword',
  data() {
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 提交表单
    handleSubmit() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true

          // 获取当前用户ID
          const userInfo = getUserInfo()
          if (!userInfo || !userInfo.userId) {
            this.$message.error('无法获取当前用户信息，请重新登录')
            this.$router.push('/login')
            return
          }

          // 准备提交的数据
          const submitData = {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          }

          // 调用修改密码API
          change_user_password(userInfo.userId, submitData)
            .then(response => {
if (response.data && response.data.success) {
                this.$message.success(response.data.message || '密码修改成功')
                // 清空表单
                this.resetForm()
                // 延迟跳转到登录页，让用户重新登录
                setTimeout(() => {
                  this.$confirm('密码已修改，请重新登录', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'success'
                  }).then(() => {
                    // 清除认证信息并跳转到登录页
                    const { clearAuth } = require('@/utils/auth')
                    clearAuth()
                    this.$router.push('/login')
                  })
                }, 500)
              } else {
                this.$message.error(response.data.message || '密码修改失败')
              }
            })
            .catch(error => {
              console.error('修改密码失败:', error)
              const errorMessage = error.response?.data?.message || error.message || '修改密码失败，请稍后重试'
              this.$message.error(errorMessage)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },

    // 取消操作
    handleCancel() {
      this.$router.back()
    },

    // 重置表单
    resetForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.change-password-container {
  padding: 20px;
  min-height: calc(100vh - 120px);

  .page-header {
    margin-bottom: 20px;

    .header-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: bold;

      .title-mark {
        width: 4px;
        height: 18px;
        background: #409EFF;
        margin-right: 10px;
      }
    }
  }

  .content-area {
    .password-card {
      max-width: 600px;
      margin: 0 auto;

      .form-section {
        .section-title {
          font-size: 16px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #EBEEF5;
        }

        .el-form-item {
          margin-bottom: 22px;
        }
      }

      .form-actions {
        margin-top: 30px;
        text-align: center;
        padding-top: 20px;
        border-top: 1px solid #EBEEF5;

        .el-button {
          margin: 0 10px;
          min-width: 100px;
        }
      }
    }
  }
}
</style>
